import templateUrl from './edit-pay-stub-entry.component.html'
import './edit-pay-stub-entry.component.less'

export const EditPayStubEntryComponent = {
    templateUrl,
    bindings: {
        payStubEntry: "<",
        useDailyRSCommission: "<useDailyRsCommission"
    }
}
